import { API_BASE, STORAGE_KEYS } from './config';

export const apiRequest = async (path, options = {}) => {
  const url = `${API_BASE}${path}`;
  const token = localStorage.getItem(STORAGE_KEYS.accessToken);
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {})
  };
  if (token && !headers.Authorization) {
    headers.Authorization = `Bearer ${token}`;
  }

  let response;
  try {
    response = await fetch(url, {
      ...options,
      headers
    });
  } catch (error) {
    localStorage.removeItem(STORAGE_KEYS.isLoggedIn);
    localStorage.removeItem(STORAGE_KEYS.username);
    localStorage.removeItem(STORAGE_KEYS.accessToken);
    localStorage.removeItem(STORAGE_KEYS.registryUrl);
    localStorage.removeItem(STORAGE_KEYS.role);
    localStorage.setItem(STORAGE_KEYS.isLoggedIn, 'false');
    throw new Error('网络异常，请稍后重试');
  }

  const data = await response.json().catch(() => ({}));

  if (response.status === 401 || response.status === 403) {
    localStorage.removeItem(STORAGE_KEYS.isLoggedIn);
    localStorage.removeItem(STORAGE_KEYS.username);
    localStorage.removeItem(STORAGE_KEYS.accessToken);
    localStorage.removeItem(STORAGE_KEYS.registryUrl);
    localStorage.removeItem(STORAGE_KEYS.role);
    localStorage.setItem(STORAGE_KEYS.isLoggedIn, 'false');
    throw new Error('登录已过期，请重新登录');
  }

  if (!response.ok) {
    const message = data?.msg || '请求失败，请稍后重试';
    throw new Error(message);
  }

  return data;
};
